module.exports = __webpack_public_path__ + "img/crx-logo-white.35d49b14.png";